module.exports = __webpack_public_path__ + "img/fless-pro.1e68f708.png";